import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Inject } from '@angular/core';
import { LoaderService } from '../../../shared/services/loader.service';
import { Observable } from 'rxjs';
import { SubscriptionService } from '../../../shared/services/subscription.service';
import { DataTableParams } from 'angular-datatables-all-versions';
export class SubscriptionsListResolver implements Resolve<any[]> {

    constructor(@Inject(SubscriptionService) private service: SubscriptionService,
        @Inject(LoaderService) private loaderService: LoaderService) { }

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any[]> {
        this.loaderService.show();
        const post_data = <DataTableParams>Object.assign({}, {
            type: ''
        })
        return this.service.list(post_data);
    }
}
